export interface Translate {
    key: string;
    keyPlural?: string;
    count?: number;
    values?: TranslateValue[];
    prefix?: string;
    suffix?: string;
    format?: LabelFormat;
}

export enum LabelFormat {
    Default,
    Capitalize,
    CapitalizeWords,
    UpperCase,
    LowerCase,
}

interface TranslateValueObject {
    value: string | number | null | undefined;
    bold?: boolean;
}

export type TranslateValue = string | number | null | undefined | TranslateValueObject;
